<script>
import { CallStatus } from '@/views/cati/enum'

export default {
  name: 'CallResult',
  data() {
    return {
      visible: false,
      options: [
        { label: '无应答', value: CallStatus.NoResponse },
        { label: '关机', value: CallStatus.Shutdown },
        { label: '停机', value: CallStatus.Halt },
        { label: '空号', value: CallStatus.Empty },
        { label: '不在服务区', value: CallStatus.NoService },
        { label: '其他', value: 10 },
      ],
      radioValue: 3,
      otherValue: ''
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onSave() {
      let val = this.options.find(item => item.value === this.radioValue).label
      let status = this.radioValue
      if (this.radioValue === 10) {
        status = CallStatus.NoResponse
        val = this.otherValue
      }
      this.$emit('confirm', status,val)
      this.onClose()
    }
  },
  mounted() {
    this.visible = true
  }
}
</script>

<template>
  <el-dialog
      :visible="visible"
      title="呼叫结果"
      @close="onClose"
      custom-class="theme-dialog split-line-footer-dialog"
      width="520px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
  >
    <div>
      <el-radio-group v-model="radioValue">
        <div v-for="item in options" :key="item.value" class="mb-2 last:mb-0">
          <el-radio :label="item.value">
            <span>{{ item.label }}</span>
          </el-radio>
        </div>
      </el-radio-group>
      <div class="mt-2" v-if="radioValue==10">
        <el-input type="textarea" :rows="4" v-model.trim="otherValue" :maxlength="100" show-word-limit
                  resize="none"></el-input>
      </div>
    </div>
    <template #footer>
      <div class="text-right">
        <el-button type="primary" @click="onSave">保 存</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">

</style>